import Vue from 'vue'
import VueRouter from 'vue-router'
import Nprogress from 'nprogress'
import TemplateAyres from '@/container/TemplateAyres'
import routesSession from '@/modules/session/routes'
import routesDashboard from '@/modules/dashboard/routes'
import routesDebtModel from '@/modules/debtModel/routes'
import routesSlides from '@/modules/slides/routes'
import routesUsers from '@/modules/user/routes'
import routesSystematicEconomics from '@/modules/systematicEconomics/routes'
import routesAdmin from '@/modules/admin/routes'
import storageUtil from '@/helpers/storage'

Vue.use(VueRouter)

const routes = [].concat(routesDashboard,
  routesDebtModel,
  routesSlides,
  routesSystematicEconomics,
  routesUsers,
  routesAdmin,
  [])

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: TemplateAyres,
      redirect: '/dashboard',
      children: routes
    }
  ].concat(routesSession)
})

router.beforeEach((to, from, next) => {
  Nprogress.start()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (storageUtil.getKey('user', true) === null) {
      next({
        name: 'login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

// navigation guard after each
router.afterEach((to, from) => {
  Nprogress.done()
  setTimeout(() => {
    const contentWrapper = document.querySelector('.v-content__wrap')
    if (contentWrapper !== null) {
      contentWrapper.scrollTop = 0
    }
  }, 200)
})

export default router